import React, { useEffect, useState } from 'react'
import { Select } from '../Select'
import { Input } from '../InputBox'
import GradientButton from '../GradientButton'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useContract } from '../../../contexts/ContractContext'

import {
  Container,
  PriceInputContainer,
  ButtonWrapper,
  SelectWrapper,
  Option,
  ErrorMessage
} from './styles'

export const FilterPrice = (props) => {
  const {
    filterValues,
    handleChangeFilterItem
  } = props

  const { invokeServer } = useGlobal()
  const { convertAtoB } = useContract()

  const [paymethodList, setPaymethodList] = useState([])
  const [errorMessage, setErrorMessage] = useState(null)
  const [currencyIds, setCurrencyIds] = useState([])
  const [priceFilter, setPriceFilter] = useState({
    payment: null,
    min: '',
    max: ''
  })

  const getPaymethodList = () => {
    invokeServer('get', '/api/payment')
      .then(r => {
        if (r.data.msg === 'ok') {
          const _paymethodList = r.data.payment.map(paymethod => {
            return { value: paymethod.id, content: <Option>{paymethod.name}</Option> }
          })
          const ids = r.data.payment.reduce((previousValue, currentValue) =>  [...previousValue, currentValue.id], [])
          setPaymethodList(_paymethodList)
          setCurrencyIds(ids)
        }
      })
      .catch(err => {
        console.log(`${err.message}`);
      })
  }

  const handleChangePaymethod = (paymethod) => {
    setPriceFilter({ ...priceFilter, payment: paymethod })
  }

  const handleFilterApply = () => {
    const paymethodIds = filterValues?.currencyTypes.length > 0 ? filterValues?.currencyTypes : currencyIds
    const _priceFilter = paymethodIds.map(paymethodId => {
      let min = ''
      let max = ''
      if (priceFilter.min !== '') min = parseFloat(convertAtoB(priceFilter.payment, paymethodId, priceFilter.min))
      if (priceFilter.max !== '') max = parseFloat(convertAtoB(priceFilter.payment, paymethodId, priceFilter.max))
      return {
        payment: paymethodId,
        min: min,
        max: max
      }
    })
    console.log(_priceFilter)
    handleChangeFilterItem('price', _priceFilter)
  }

  const handleChangeFilter = (evt) => {
    setPriceFilter({ ...priceFilter, [evt.target.name]: evt.target.value })
  }

  useEffect(() => {
    getPaymethodList()
  }, [])

  useEffect(() => {
    if (priceFilter?.max !== '' && priceFilter?.min !== '' && parseFloat(priceFilter?.max) < parseFloat(priceFilter?.min)) {
      setErrorMessage('Minimum must be less than maximum')
    } else {
      setErrorMessage(null)
    }
  }, [priceFilter?.max, priceFilter?.min])

  return (
    <Container>
      <SelectWrapper>
        <Select
          notReload
          options={paymethodList}
          placeholder='Select a payment'
          defaultValue={priceFilter.payment}
          onChange={val => handleChangePaymethod(val)}
        />
      </SelectWrapper>
      <PriceInputContainer>
        <Input
          value={priceFilter.min}
          name='min'
          onKeyPress={(e) => {
            if (!/^[0-9.]$/.test(e.key)) {
              e.preventDefault()
            }
          }}
          onChange={handleChangeFilter}
          placeholder='Min'
        />
        <span>to</span>
        <Input
          value={priceFilter.max}
          onKeyPress={(e) => {
            if (!/^[0-9.]$/.test(e.key)) {
              e.preventDefault()
            }
          }}
          name='max'
          onChange={handleChangeFilter}
          placeholder='Max'
        />
      </PriceInputContainer>
      <ErrorMessage>{errorMessage}</ErrorMessage>
      <ButtonWrapper active={priceFilter?.payment !== null && (parseFloat(priceFilter?.max) >= 0 || parseFloat(priceFilter?.min) >= 0) }>
        <GradientButton
          label={'Apply'}
          height={'36px'}
          width={'106px'}
          fontSize={'14px'}
          handleClick={() => handleFilterApply()}
        />
      </ButtonWrapper>
    </Container>
  )
}
